import SnackbarSystem from '@ui/systems/SnackbarSystem';
import User from '../../new_arch/models/user/user';
import OnboardingSurveyStep from './components/OnboardingSurveyStep';
import useOnboardingSurveyPopup from './hooks/useOnboardingSurveyPopup';

import './OnboardingSurveyPopup.scss';

type OnboardingSurveyPopupProps = {
	user: User,
	onClose: () => void,
	snackbarSystem?: SnackbarSystem
}

const OnboardingSurveyPopup = ( { user, snackbarSystem, onClose }: OnboardingSurveyPopupProps ) => {
	const {
		currentField,
		isLoading
	} = useOnboardingSurveyPopup( { userId: user.id, snackbarSystem, onClose } );

	return (
		<div className="OnboardingSurveyPopup">
			<OnboardingSurveyStep
				user={user}
				isLoading={isLoading}
				{...currentField}
			/>
		</div>
	)
}

export default OnboardingSurveyPopup;
